import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import {
  get_wallet_packagename,
  get_single_wallet_packagename,
} from "../../../store/actions/CommanAction";
import Loader from "../Loader/Loader";

const WalletPackageName = () => {
  const dispatch = useDispatch();
  const PackageName = useSelector(
    (state) => state.feedBackReducer.GetWalletPackageName
  );
  const SinglaDataPackageName = useSelector(
    (state) => state.feedBackReducer.GetSingleWalletPackageName
  );
 

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [PackageNameID, setPackageNameID] = useState("");
  const [loading, setloading] = useState(false);

  const [addFormData, setaddFormData] = useState({
    Name: "",
    CreatedByUser: "1",
    IsActive: "1",
  });

  const Reset = () => {
    setaddFormData({ ...addFormData, Name: "" });
  };

  useEffect(() => {
    if (SinglaDataPackageName) {
      setEditValue(SinglaDataPackageName);
    }
  }, [SinglaDataPackageName]);

  useEffect(() => {
      dispatch(get_wallet_packagename());
  }, [ IsActive]);

  useEffect(() => {
    if (EditValue && EditValue.length > 0) {
      setaddFormData({
        ...addFormData,
        PackageNameID: PackageNameID,
        Name: EditValue[0]?.PlanName,
        ModifiedByUser: "1",
      });
    }
  }, [EditValue]);

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    let modifiedtrim=addFormData.Name.trim();
    if (!modifiedtrim) {
      error = true;
      errorMsg = "Please fill Package Name.";
    }
    if (!error) {
      const newCustomerStory = {
        PlanName: addFormData.Name,
        
      };
      await AddUpdate("WalletPlanName/Insert_WalletPlanName", newCustomerStory);
      setPostModal(false);
      dispatch(get_wallet_packagename());
      swal("Good job!", "Successfully Added", "success");
      Reset();
      setaddFormData({ Name: "" });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const UpdateSlider = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    let modifiedName=addFormData.Name.trim();
    if (!modifiedName) {
      error = true;
      errorMsg = "Please fill Package Name.";
    }
    if (!error) {
      const updatedata={ PlanName:addFormData.Name,
        PlanId:PackageNameID
      }
      await AddUpdate("WalletPlanName/Update_WalletPlanName", updatedata);
      setEditModal(false);
      dispatch(get_wallet_packagename());
      swal("Good job!", "Successfully update", "success");
      Reset();
      setaddFormData({ Name: "" });
    } 
    else {
      swal("Oops", errorMsg, "error");
    }
  };

  const handleAddFormChange = (e) => {
  
    
    setaddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleEditClick = (row) => {
    dispatch(get_single_wallet_packagename(row?.PlanId));
    setPackageNameID(row?.PlanId);
    setEditModal(true);
  };

  const columns = [
    {
      name: "PlanName",
      selector: (row) => row.PlanName,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                className={row.IsActive ? "text-danger" : "text-success"}
                onClick={() => {
                  handleToggleStatusClick(row.PlanId, true, "0");
                }}
              >
                Inactive
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];



  const handleToggleStatusClick = async (
    PackageNameID,
    
  ) => {
    const postData = {
      PlanId: PackageNameID,
      
    };
    await AddUpdate("WalletPlanName/Delete_WalletPlanName", postData);
    dispatch(get_wallet_packagename());
    swal(
      "Good job!",
      `Successfully Deleted`,
      "success"
    );
  };

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap main_card">
         
          <Link
            to={"#"}
            className="btn btn-primary font-w600 "
            onClick={() => {
              setPostModal(true);
              Reset();
            }}
          >
            + New Package Name
          </Link>
        </div>
        <div className="row main_card">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-5 d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">
                              Add Package Name
                            </h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <label htmlFor="">Package Name</label>
                                <span className="text-danger star-error">
                                  *
                                </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  autoComplete="off"
                                  name="Name"  
                                  required="required" 
                                  value={addFormData?.Name}
                                  onChange={handleAddFormChange}
                                />
                              </div>
                            </div>
                          </div>    
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Edit Package Name
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                                <div className="add-contact-content">
                                  <label htmlFor="">Package Name</label>
                                  <span className="text-danger star-error">
                                    *
                                  </span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="Name"
                                    required="required"
                                    value={addFormData?.Name}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateSlider}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={PackageName}
                          columns={columns}
                          selectableRowsHighlight
                          pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      )}
                    </div>
                  </Tab.Pane>
                 
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default WalletPackageName;
